import erc20Abi from "./abis/erc20.json";
import legislatoorAbi from "./abis/legislatoor.json";

const abis = {
  erc20: erc20Abi,
  legislatoor: legislatoorAbi,
};

export default abis;
